import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import AppStore from '../assets/images/AppStore.png';
import GooglePlay from '../assets/images/google play.png';
import {
  appStoreUrl,
  googlePlayUrl,
  openAppStoreWithOpenAIAds,
  trackOpenAIAdsAppDownloadClick
} from '../lib/openaiAds';
import { trackAppStoreClick } from '../lib/metaPixel';
import AppStoreQrHover from './AppStoreQrHover';
import ScrollSectionBackground from './ScrollSectionBackground';

const Footer = () => {
  const handleWaitlistClick = () => {
    trackAppStoreClick('footer_try_for_free');
    openAppStoreWithOpenAIAds('footer_try_for_free');
  };

  return (
    <div className="bottom-gradient-section">
      <ScrollSectionBackground edge="bottom" />
      <div className="bottom-content-container">
        <div className="gradient-rectangle">
          <h2 className="gradient-text">Try Uncling today.</h2>
          <p className="gradient-subtitle">Heal From Heartbreak.</p>
          <AppStoreQrHover placement="top" className="app-store-qr-hover--gradient">
            <button className="gradient-button" onClick={handleWaitlistClick}>
              <span>Try For Free</span>
            </button>
          </AppStoreQrHover>
        </div>
      </div>
      <div className="footer-links">
        <div className="footer-column footer-download-column">
          <h3 className="footer-download-title">Heal from heartbreak.</h3>
          <div className="footer-store-buttons">
            <AppStoreQrHover placement="top">
              <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" onClick={() => {
                trackAppStoreClick('footer_store_badge');
                trackOpenAIAdsAppDownloadClick('app_store', 'footer_store_badge');
              }}>
                <img src={AppStore} alt="Download on the App Store" className="footer-store-button footer-app-store" />
              </a>
            </AppStoreQrHover>
            <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackOpenAIAdsAppDownloadClick('google_play', 'footer_store_badge')}>
              <img src={GooglePlay} alt="Get it on Google Play" className="footer-store-button footer-google-play" />
            </a>
          </div>
          <p className="footer-download-copyright">© Sefr Development LLC 2026. All rights reserved.</p>
        </div>
        <div className="footer-column">
          <h3>COMPANY</h3>
          <Link to="/about">About Us</Link>
          <Link to="/careers">Careers</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/faqs">FAQs</Link>
        </div>
        <div className="footer-column">
          <h3>RESOURCES</h3>
          <Link to="/blog">Blog</Link>
          <Link to="/security">Security</Link>
          <Link to="/privacy-policy">Privacy policy</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
          <Link to="/attachment-style-quiz">Attachment style quiz</Link>
        </div>
      </div>
      <div className="footer-wordmark" aria-hidden="true">uncling</div>
    </div>
  );
};

export default Footer;
